export const TransformSendData = (data) => {
    const results=[]
    Object.keys(data).forEach((partName)=>{
        Object.keys(data[partName]).forEach((categoryName)=>{
            Object.keys(data[partName][categoryName]).forEach((levelName)=>{
                Object.keys(data[partName][categoryName][levelName]).forEach((taskName)=>{
                    let task_value=data[partName][categoryName][levelName][taskName]
                    if (task_value["changed"]==true){
                        results.push({
                            "part_name": partName,
                            "category": categoryName,
                            "level": Number(levelName),
                            "question_number": Number(taskName),
                            "result": task_value.result,
                            "comment": task_value.comment
                        });
                    }
                })
            })
        })
    })

    return results;
}